import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Swal from 'sweetalert2';

import VerifiedIcon from "@mui/icons-material/Verified";
import CancelIcon from "@mui/icons-material/Cancel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { useEffect, useMemo } from "react";
import countryList from "react-select-country-list";
// import Receipt from './Receipt';

//import Modal from 'react-modal';

import Box from "@mui/material/Box";

import Modal from "@mui/material/Modal";
import axios from "axios";

import {
  Container,
  Typography,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Grid,
  Paper,
  useTheme,
  styled,
  InputLabel,
  Checkbox,
} from "@mui/material";
import { adduser, payPalPayment, sendOrderId } from "./lib/api-payment";

import "./App.css";
import {
  ADD_BASE_PATH,
  Add_BASE_PATH,
  PAYMENT_BASE_PATH,
  RAZOR_BASE_PATH,
} from "./lib/api-base-path";
import dayjs from "dayjs";

// import {DatePicker} from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const StyledContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(4),
  marginTop: theme.spacing(4),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  borderRadius: theme.spacing(1),
}));

const StyledFormControl = styled(FormControl)({
  marginBottom: ({ theme }) => theme.spacing(2),
});

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
function HomePage() {
  const theme = useTheme();
  const [Course, setCourse] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paymentData, setPaymentData] = useState(null);

  const options = useMemo(() => countryList().getData(), []);

  const [value, setValue] = useState(null);
  const [value1, setValue1] = useState(null);
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState(0);
  const [amountevent, setAmountEvet] = useState(0);
  const [openfail, setOpenfail] = useState(false);
  const [openfail2, setOpenfail2] = useState(false);
  const handleClose = () => setOpen(false);
  const handleClose2 = () => setOpen2(false);
  const handleClosefail = () => setOpenfail(false);
  const handleClosefail2 = () => setOpenfail2(false);
  const [orderid, setOrderid] = useState([""]);
  const [open2, setOpen2] = useState(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  //const navigate = useNavigate();
  const [clickon,setClickon]= useState(false)
  const [selectedValue, setSelectedValue] = useState(null);
  const [formData, setFormData] = useState({
    country: "",
    memberType: "",
    registrationType: "",
    name: "",
    email: "",
    organization: "",
    designation: "",
    address: "",
    postalCode: "",
    dob: dayjs(Date.now()),
    passportNo: "",
    dateOfIssue: dayjs(Date.now()),
    dateOfExpiry: dayjs(Date.now()),
    placeOfIssue: "",
    dateOfArrival: dayjs(Date.now()),
    dateOfDeparture: dayjs(Date.now()),
  });

  let defaultAmount ;
  const calculateRateWithGST = (baseRate) => {
    return baseRate + (baseRate * 0.18);
  };
  if (selectedValue === "India") {
    if (amount === 10) {
      defaultAmount = 120;
      // defaultAmount = 1;

      console.log(`Setting amount and amountevent to ${defaultAmount}`);
    } else if (amount ==  1) {
      defaultAmount = 8000;

      console.log(`Setting amount and amountevent to ${defaultAmount}`);
    } else if (amount === 2) {
      defaultAmount = 60;

      console.log(`Setting amount and amountevent to ${defaultAmount}`);
    } else if (amount ===  3) {
      defaultAmount = 60;

      console.log(`Setting amount and amountevent to ${defaultAmount}`);
    } 
  } else {
    if (amount === 10) {
      defaultAmount = calculateRateWithGST(120);

      console.log(`Setting amount and amountevent to ${defaultAmount}`);
    } else if (amount === 1) {
      defaultAmount = calculateRateWithGST(95);

      console.log(`Setting amount and amountevent to ${defaultAmount}`);
    } else if (amount === 2) {
      defaultAmount = calculateRateWithGST(60);

      console.log(`Setting amount and amountevent to ${defaultAmount}`);
    } else if (amount ===  3) {
      defaultAmount = calculateRateWithGST(60);

      console.log(`Setting amount and amountevent to ${defaultAmount}`);
    }
  }
  useEffect(() => {
    
    localStorage.setItem("defaultAmount", defaultAmount);
  }, [amount, amountevent]);

  

  const handleInputChange = (field, value) => {
    
    setFormData({
      ...formData,
      [field]: value,
    });
 
  
    if (field === "memberType") {
      setValue(null);
    }
   
  }
   

  useEffect(() => {
    
  }, [value]);
  console.log(amount)
  
  const handleInputChange1 = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });

    if (field === "registrationType") {
      setValue1(null);
    
      const selectedOption = [
        { label: "Only Symposium Registration", value: 10 },
        { label: "Workshop + Short Courses Registration", value: 1 },
        { label: "Accompanying Person if any", value: 3 },
        { label: "Full Registration", value: 2 },
      ].find((option) => option.label === value);

      if (selectedOption) {
        setAmountEvet(selectedOption.value);
        
      }
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [book] = useState({
    name: "The Fault In Our Stars",
    author: "John Green",
    img: "https://images-na.ssl-images-amazon.com/images/I/817tHNcyAgL.jpg",
    price: 250,
  });

  const handleCloseModal = () => {
    setModalOpen(false);
    closeModal();
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    alignItems: "center",
    alignContent: "center",
    textAlign: "center",
    p: 4,
  };

  const handleAutocompleteChange = (event, newValue) => {
    if (newValue && Object.keys(newValue).length > 0) {
      
      setSelectedValue(newValue.label);
      setFormData({
        ...formData,
        country: newValue.label,
      });
    } else {
      setSelectedValue(null);
    }
  };
  useEffect(() => {
    if (openfail2 && orderid) {
      handleSubmitpaypalfail();
    }
  }, [openfail2]);
  const createOrder = async () => {
    const storedDefaultAmount = localStorage.getItem("defaultAmount");
    const shouldDisableCheckbox = localStorage.getItem("isCheckboxDisabled");
    const click = localStorage.getItem("Checkbox")
    const currentDate = dayjs();
    
const discountExpiryDate = dayjs('2024-05-31');

const applyDiscount = currentDate <= discountExpiryDate;

let discountedAmount = parseInt(storedDefaultAmount);

if (applyDiscount) {
  
  discountedAmount = Math.round(discountedAmount * 0.9);
}

localStorage.setItem('discountedAmount', discountedAmount);
    const response = await payPalPayment({
      cost: discountedAmount,
      shouldDisableCheckbox:shouldDisableCheckbox,
      click:click

    });
    const id = response.data?.jsonResponse?.id;

    if (id) {
      
      setOrderid(id);
      return id;
    } else {
      console.error("Failed to retrieve orderId from the response object.");
      return null;
    }
  };

  const onApprove = async (orderId) => {
    try {
      const paymedantData = await sendOrderId(orderId);
      setPaymentData(defaultAmount);
      const captureId =
        paymedantData.data.jsonResponse.purchase_units[0].payments.captures[0]
          .id;
  
      handleSubmitpaypal(captureId);
      setOpen(true);
    } catch (error) {
      console.error("Error processing PayPal payment:", error);
      handleSubmitpaypalfail();
      setOpenfail2(true);
    }
  };

  const initPayment = (data) => {
    const options = {
      // key: "rzp_live_yhgIBqTwpGyP3Z",
      key: "rzp_test_StbZBonzDungvA",
      amount: data.amount,
      currency: data.currency,
      name: book.name,
      description:`${formData.name}${formData.email}`,
      image: book.img,
      order_id: data.id,
      handler: async (response) => {
        try {
          setOrderid(options.order_id);
          const verifyUrl = `${RAZOR_BASE_PATH}/verify`;
          const { data: verificationData } = await axios.post(
            verifyUrl,
            response
          );
          

          if (verificationData.message === "Payment verified successfully") {
    
            await handleSubmit(options);
            setOpen2(true);
          
          } else {
        
            console.error("Payment verification failed");
            
            await handleSubmitFail(options);
            setOpenfail(true);
          }
        } catch (error) {
          console.log(error);
          console.log("options", options);
          await handleSubmitFail(options);
          
          setOpenfail(true);
        }
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };

  const handlePayment = async (event) => {
    if (event) {
      event.preventDefault();
    }
    try {
      const storedDefaultAmount = localStorage.getItem("defaultAmount");
      const click = localStorage.getItem("Checkbox")
      const currentDate = dayjs();
      const discountExpiryDate = dayjs('2024-05-31');
  
      const applyDiscount = currentDate <= discountExpiryDate;
  
      let discountedAmount = parseInt(storedDefaultAmount);
  
      if (applyDiscount) {
    
        discountedAmount = Math.round(discountedAmount * 0.9);
      }
  
      localStorage.setItem('discountedAmount', discountedAmount);
      
      const orderUrl = `${RAZOR_BASE_PATH}/razorPayment`;
      const { data } = await axios.post(orderUrl, { amount: discountedAmount,setIsCheckboxDisabledbox: isCheckboxDisabled,check:click });
      
      initPayment(data.data);

    } catch (error) {
      console.log(error);
    }
  };

  const isFormValid = () => {
    // Add logic to check if all required fields are filled
    console.log(formData);
  
    if (formData.country === "India") {
      return (
        formData.country &&
        formData.memberType &&
        formData.name &&
        formData.email &&
        formData.organization &&
        formData.designation &&
        formData.address &&
        formData.postalCode &&
        formData.dob
      );
    } else {
      return (
        formData.country &&
        formData.memberType &&
        formData.name &&
        formData.email &&
        formData.organization &&
        formData.designation &&
        formData.address &&
        formData.postalCode &&
        formData.dob &&
        formData.dateOfExpiry &&
        formData.placeOfIssue
      );
    }
  };
  useEffect(() => {
    const storedFormData1 = localStorage.getItem("formData");
    const Checkbox = localStorage.getItem("Checkbox")
    setClickon(Checkbox === 'true'?true:false)
    if (storedFormData1) {
    
      const storedFormData = JSON.parse(storedFormData1);
      setFormData({
        ...storedFormData, 
        dob: dayjs(storedFormData.dob),
        dateOfIssue: dayjs(storedFormData.dateOfIssue),
        dateOfExpiry: dayjs(storedFormData.dateOfExpiry),
        dateOfArrival: dayjs(storedFormData.dateOfArrival),
        dateOfDeparture: dayjs(storedFormData.dateOfDeparture),
        memberType:"",
        registrationType:""
      });
    }
  }, []);
  useEffect(() => {
    localStorage.setItem("formData", JSON.stringify(formData));
  }, [formData]);
  const handleSubmit = async (options) => {
    const currentDate = dayjs();
    const click = localStorage.getItem("Checkbox")
    const discountExpiryDate = dayjs('2024-05-31');
    const applyDiscount = currentDate <= discountExpiryDate;
    let discountedAmount = defaultAmount;
  
    if (applyDiscount) {
    
      discountedAmount = Math.round(discountedAmount * 0.9);
    }
  
    const requestData = {
      ...formData,
      orderId: options.order_id,
      amount: discountedAmount,
      payment_type: "RazorPay",
      status: 1,
      setIsCheckboxDisabledbox: isCheckboxDisabled,
      click:click
    };

    try {
      
      const response = await axios.post(
        `${ADD_BASE_PATH}/adddata`,
        requestData
      );

      
        localStorage.clear();
        window.location.reload(true);
    
    } catch (error) {

      console.error("Error submitting data to the backend:", error);
    }
  };

  const handleSubmitFail = async (options) => {
    const currentDate = dayjs();
    const discountExpiryDate = dayjs('2024-05-31');
    const applyDiscount = currentDate <= discountExpiryDate;
    let discountedAmount = defaultAmount;
  
    if (applyDiscount) {

      discountedAmount = Math.round(discountedAmount * 0.9);
    }
  
    const requestData = {
      ...formData,
      orderId: options.order_id,
      amount: discountedAmount,
      payment_type: "RazorPay",
      status: 0,
      setIsCheckboxDisabledbox: isCheckboxDisabled
    };

    try {
      const response = await axios.post(
        `${ADD_BASE_PATH}/adddata`,
        requestData
      );

      localStorage.clear();
      window.location.reload(true);
    } catch (error) {
     
      console.error("Error submitting data to the backend:", error);
    }
  };

  const handleSubmitpaypal = async (captureId) => {
    const storedFormData = localStorage.getItem("formData");
    const parsedFormData = storedFormData ? JSON.parse(storedFormData) : {};
    const storedDefaultAmount = localStorage.getItem("defaultAmount");
    const shouldDisableCheckbox = localStorage.getItem("isCheckboxDisabled");
    const click = localStorage.getItem("Checkbox")
    const currentDate = dayjs();
    const discountExpiryDate = dayjs('2024-05-31');
    const applyDiscount = currentDate <= discountExpiryDate;
  
    let discountedAmount = parseInt(storedDefaultAmount);
  
    if (applyDiscount) {
      discountedAmount = Math.round(discountedAmount * 0.9);
    }
  
    const requestData = {
      ...parsedFormData,
      orderId: captureId,
      amount: discountedAmount,
      payment_type: "PayPal",
      status: 1,
      shouldDisableCheckbox:shouldDisableCheckbox,
      click:click

    };

    try {
      
      const response = await axios.post(
        `${ADD_BASE_PATH}/adddata`,
        requestData
      );

      localStorage.clear();
        window.location.reload(true);
  
    } catch (error) {
  
      console.error("Error submitting data to the backend:", error);
    }
  };
  const handleSubmitpaypalfail = async () => {
  
    if (orderid === null) {
      
      return;
    } else {
      const storedFormData = localStorage.getItem("formData");
      const parsedFormData = storedFormData ? JSON.parse(storedFormData) : {};
      const storedDefaultAmount = localStorage.getItem("defaultAmount");
      const shouldDisableCheckbox = localStorage.getItem("isCheckboxDisabled");
      const currentDate = dayjs();
      const discountExpiryDate = dayjs('2024-05-31');
      const applyDiscount = currentDate <= discountExpiryDate;
    
      let discountedAmount = parseInt(storedDefaultAmount);
    
      if (applyDiscount) {
      
        discountedAmount = Math.round(discountedAmount * 0.9);
      }
    
      const requestData = {
        ...parsedFormData,
        orderId: orderid,
        amount: discountedAmount,
        payment_type: "PayPal",
        status: 0,
        shouldDisableCheckbox:shouldDisableCheckbox
      };

      try {
        
        const response = await axios.post(
          `${ADD_BASE_PATH}/adddata`,
          requestData
        );

        localStorage.clear();
        window.location.reload(true);
    
      } catch (error) {
  
        console.error("Error submitting data to the backend:", error);
      }
    }

  };
   
   useEffect(() => {
    const shouldDisableCheckbox = (amount === 2 || amount === 3);
    setIsCheckboxDisabled(shouldDisableCheckbox);
    localStorage.setItem('isCheckboxDisabled', shouldDisableCheckbox);
  }, [amount]);
  
 
  
  
  const addbutton = async (event) => {
    event.preventDefault();
    try {
      const updatedFormData = {
        ...formData,
        checkedItems: checkedItems,
      };
      const response = await adduser(updatedFormData);
      console.log('User added successfully:', response.data);
      Swal.fire({
        title: 'Thank you for submitting your details.',
        text: 'Our team will contact you soon and share your registration confirmation details along with Payment links.',
        icon: 'success',
        confirmButtonText: 'OK'
      }).then(() => {
        localStorage.removeItem('formData');
        window.location.reload();
      });
      // window.alert("Data Added successfully")
      // localStorage.removeItem('formData');
      // window.location.reload();
    } catch (error) {
      console.error('Error adding user:', error);
    }
  };
  const isAddButtonDisabled = () => {
    // Add conditions for required fields
    return (
   
      !formData.country ||
      !formData.memberType ||
      !formData.registrationType  ||
      !formData.email ||
      !formData.organization ||
      !formData.designation ||
      !formData.address ||
      !formData.postalCode ||
      !formData.passportNo ||
      !formData.placeOfIssue 
      

    );
  };
  const reset=()=>{
    setFormData({
      country: "",
    memberType: "",
    registrationType: "",
    name: "",
    email: "",
    organization: "",
    designation: "",
    address: "",
    postalCode: "",
    dob: dayjs(Date.now()),
    passportNo: "",
    dateOfIssue: dayjs(Date.now()),
    dateOfExpiry: dayjs(Date.now()),
    placeOfIssue: "",
    dateOfArrival: dayjs(Date.now()),
    dateOfDeparture: dayjs(Date.now()),
    
    })
  }
  const cellStyle = {
    border: '1px solid black',
    padding: '10px',
    textAlign: 'left'
};
const handleCheckboxChange = (event) => {
  const { name, checked } = event.target;
  if (checked) {
    // If checkbox is checked, add it to the checkedItems array
    setCheckedItems((prevCheckedItems) => [...prevCheckedItems, name]);
  } else {
    // If checkbox is unchecked, remove it from the checkedItems array
    setCheckedItems((prevCheckedItems) =>
      prevCheckedItems.filter((item) => item !== name)
    );
  }
};

  return (
    <>
      <StyledContainer
        maxWidth="md"
        theme={theme}
        sx={{ backgroundColor: "#d0f4de" }}
      >
        <StyledPaper elevation={3} theme={theme}>
          <Typography variant="h4" align="center" gutterBottom>
            Registration Form
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={options}
                  sx={{ width: "flex" }}
                  onChange={handleAutocompleteChange}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Country" />
                  )}
                  
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <StyledFormControl fullWidth>
                  <RadioGroup
                   defaultValue=""
                    aria-label="Member Type"
                    name="memberType"
                    value={formData.memberType}
                    onChange={(e) =>
                      handleInputChange("memberType", e.target.value)
                    }
                  >
                    {[
                      { label: "ICOLD Members", value: 10 },
                      { label: "SAARC Countries", value: 1 },
                      { label: "ICOLD Young Delegates", value: 2 },
                      { label: "ICOLD Research Students", value: 3 },
                      { label: "WS/SC Speaker", value: 4 },
                      
                    ].map((option) => (
                      <FormControlLabel
                        key={option.value}
                        value={option.label}
                        control={<Radio />}
                        label={option.label}
                        onChange={() => setAmount(option.value)}
                      />
                    ))}
                  </RadioGroup>
                 
                </StyledFormControl>
              </Grid>

              
        <Grid item xs={12} md={12}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        
            <tbody>
            <tr>
                <td style={{ ...cellStyle, verticalAlign: 'top' }}>
            Short Courses</td>
                    <td style={{ ...cellStyle, verticalAlign: 'top' }}>
              
                      Workshops</td>
                </tr>
                <tr>
                <td style={{ ...cellStyle, verticalAlign: 'top' }}>
                <Checkbox
              name="SC-1"
              checked={checkedItems.includes('SC-1')}
              onChange={handleCheckboxChange}
            
          />Short course on surveillance and Monitoring 
                    for Tailings and Embankment Dams</td>
                    <td style={{ ...cellStyle, verticalAlign: 'top' }}>
                    <Checkbox
              name="WS-1"
              checked={checkedItems.includes('WS-1')}
              onChange={handleCheckboxChange}
            />
                      Workshop: Design of tailing Dams for closure</td>
                </tr>
                <tr>
                <td style={{ ...cellStyle, verticalAlign: 'top' }}>
                <Checkbox
              name="SC-2"
              checked={checkedItems.includes('SC-2')}
              onChange={handleCheckboxChange}
            />
                      Workshop bulletin 194: Tailings Dams Safety
                      
                      </td>
                      <td style={{ ...cellStyle, verticalAlign: 'top' }}>
                      
                      
          
          Technical Tour :
          <br />
          <Checkbox
              name="T-1"
              checked={checkedItems.includes('T-1')}
              onChange={handleCheckboxChange}
            />  (a) 2 days visit to udaipur with tour of TSF at Hindustan zinc zawar zinc refinery ( wed 25th/Thursday 26th sept.2024)
          <br />
          <Checkbox
              name="T-2"
              checked={checkedItems.includes('T-2')}
              onChange={handleCheckboxChange}
            />   (b) one day visit to jhajjar ash pond
        </td>
                </tr>
                <tr>
                <td style={{ ...cellStyle, verticalAlign: 'top' }}>
                <Checkbox
              name="SC-3"
              checked={checkedItems.includes('SC-3')}
              onChange={handleCheckboxChange}
            
          />The CDA SC on Dam Break Analysis</td>
                    <td style={{ ...cellStyle, verticalAlign: 'top' }}>
                  </td>
                </tr>
            </tbody>
        </table>
              </Grid>
              <Grid item xs={12} md={4}>
                <StyledFormControl fullWidth>
                  <TextField
                    label="Name"
                    variant="outlined"
                    value={formData.name}
                    onChange={(e) => handleInputChange("name", e.target.value)}
                    required
                  />
                </StyledFormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <StyledFormControl fullWidth>
                  <TextField
                    label="Email"
                    variant="outlined"
                    value={formData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    required
                  />
                </StyledFormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <StyledFormControl fullWidth>
                  <TextField
                    label="Organization"
                    variant="outlined"
                    value={formData.organization}
                    onChange={(e) =>
                      handleInputChange("organization", e.target.value)
                    }
                    required
                  />
                </StyledFormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <StyledFormControl fullWidth>
                  <TextField
                    label="Designation"
                    variant="outlined"
                    value={formData.designation}
                    onChange={(e) =>
                      handleInputChange("designation", e.target.value)
                    }
                    required
                  />
                </StyledFormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <StyledFormControl fullWidth>
                  <TextField
                    label="Address for Correspondence"
                    variant="outlined"
                    value={formData.address}
                    onChange={(e) =>
                      handleInputChange("address", e.target.value)
                    }
                    required
                  />
                </StyledFormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <StyledFormControl fullWidth>
                  <TextField
                    label="Postal Code"
                    variant="outlined"
                    value={formData.postalCode}
                    onChange={(e) =>
                      handleInputChange("postalCode", e.target.value)
                    }
                    required
                  />
                </StyledFormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
               
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
              
                    <DatePicker
                      value={formData.dob}
                      onChange={(date) => handleInputChange("dob", date)}
                      format="DD-MM-YYYY" // Specify the desired format
                      slotProps={{
                        
                        textField: {
                          label:"Date Of Birth",
                          name: "dob",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <StyledFormControl fullWidth>
                  <TextField
                    label="Passport No"
                    variant="outlined"
                    value={formData.passportNo}
                    onChange={(e) =>
                      handleInputChange("passportNo", e.target.value)
                    }
                    required
                  />
                </StyledFormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      placeholder="Date of Issue"
                      format="YYYY-MM-DD"
                      value={formData.dateOfIssue} // Set the value prop
                      onChange={(date) =>
                        handleInputChange("dateOfIssue", date)
                      } // Update the state on change
                      slotProps={{
                        textField: {
                          label:"Date Of Issue",
                          name: "dateOfIssue", // Ensure the correct field name is used
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
       
                    <DatePicker
                      placeholder="Date of Expiry"
                      format="YYYY-MM-DD"
                      value={formData.dateOfExpiry} // Set the value prop
                      onChange={(date) =>
                        handleInputChange("dateOfExpiry", date)
                      } // Update the state on change
                      slotProps={{
                        textField: {
                          label:"Date of Expiry",
                          name: "dateOfExpiry", // Ensure the correct field name is used
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <StyledFormControl fullWidth>
                  <TextField
                    label="Place of Issue"
                    variant="outlined"
                    value={formData.placeOfIssue}
                    onChange={(e) =>
                      handleInputChange("placeOfIssue", e.target.value)
                    }
                    required
                  />
                </StyledFormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                  
                      <DatePicker
                        placeholder="Date of Arrival"
                        format="YYYY-MM-DD"
                        value={formData.dateOfArrival} // Set the value prop
                        onChange={(date) =>
                          handleInputChange("dateOfArrival", date)
                        } // Update the state on change
                        slotProps={{
                          textField: {
                            label:"Date of Arrival",
                            name: "dateOfArrival", // Ensure the correct field name is used
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
              
                    <DatePicker
                      placeholder="Date of Departure"
                      format="YYYY-MM-DD"
                      value={formData.dateOfDeparture} // Set the value prop
                      onChange={(date) =>
                        handleInputChange("dateOfDeparture", date)
                      } // Update the state on change
                      slotProps={{
                        textField: {
                          label:"      Date of Departure:",
                          name: "dateOfDeparture", // Ensure the correct field name is used
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            </Grid>
            <Grid style={{ marginTop: "20px" }}>
            <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  onClick={addbutton}
                  disabled={!isFormValid()}
                >
                  Save
                </Button>
            </Grid>
            {/* <Grid style={{ marginTop: "20px" }}>
              {selectedValue === "India" ? (
                <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  onClick={handlePayment}
                  color="success"
                  disabled={!isFormValid()}
                >
                  Proceed With Razorpay
                </Button>
              ) : (
                <PayPalButtons
                  style={{ marginTop: "30px" }}
                  createOrder={(data, actions) => createOrder(data, actions)}
                  onApprove={(data, actions) => onApprove(data, actions)}
                  disabled={!isFormValid()}
                />
              )}
            </Grid> */}
          </form>
        </StyledPaper>

      </StyledContainer>
    </>
  );
}

export default HomePage;
